// Analytics — fire-and-forget event tracking to /api/analytics/events.
//
// Rules of engagement:
//   • Never await track() — it must not slow down a user interaction.
//   • Failures are silent (we can't afford errors here to block flows).
//   • Every A/B-testable event should carry the variant it was seen
//     under, so downstream analytics can attribute conversions.

import api from "@/lib/api";
import { isNativeApp, nativePlatform } from "@/lib/native";

function currentPlatform() {
  try {
    if (isNativeApp()) return nativePlatform() || "ios";
  } catch (_) {}
  return "web";
}

/**
 * Send an analytics event. Non-blocking — returns void immediately and
 * the underlying POST resolves in the background.
 *
 * @param {string} event  One of the whitelisted keys — mirror backend list.
 * @param {object} [properties]  Any additional payload (dollar values, ids, etc).
 * @param {object} [opts]
 * @param {string} [opts.variant]  Paywall / experiment variant seen at event time.
 */
export function track(event, properties = {}, opts = {}) {
  try {
    const body = {
      event,
      properties: properties || {},
      platform: currentPlatform(),
      variant: opts.variant || null,
    };
    // Fire-and-forget — no `await`, no `.then()` that could throw.
    api.post("/analytics/events", body).catch(() => {});
  } catch (_) { /* swallowed */ }
}
